import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Account from "./pages/Account";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import { AuthProvider } from "./lib/auth";
import "@/App.css";
import { setLenis, scrollToId } from "./lib/scroll";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Feelings } from "./components/Feelings";
import { Marquee } from "./components/Marquee";
import { HowItWorks } from "./components/HowItWorks";
import { Showcase } from "./components/Showcase";
import { WhoFor } from "./components/WhoFor";
import { SignUp } from "./components/SignUp";
import { Footer } from "./components/Footer";

function Landing() {
  const [intent, setIntent] = useState(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09 });
    setLenis(lenis);
    let id = requestAnimationFrame(function raf(t) { lenis.raf(t); id = requestAnimationFrame(raf); });
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  const openSignup = (type) => {
    setIntent({ type, at: Date.now() });
    scrollToId("signup");
  };

  return (
    <div className="App bg-paper">
      <a href="#signup" className="skip-link">Skip to sign up</a>
      <Nav onOpenSignup={openSignup} />
      <main>
        <Hero onOpenSignup={openSignup} />
        <Feelings />
        <Marquee />
        <HowItWorks />
        <Showcase />
        <WhoFor />
        <SignUp intent={intent} />
      </main>
      <Footer />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/account" element={<Account />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
